import * as React from "react";
import { observer } from "mobx-react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";
import { Pager } from "../utils/Pager";
import { Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover, TextArea } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { toast } from "react-toastify";
const InputMask = require("react-input-mask");

var debounce = require('lodash.debounce');

@observer
export default class ProdutosGenericosSped extends React.Component<{}, {}> {
    obs = observable({
        open_edit_produto_generico: false as boolean,

        produto_generico_cest: "" as string,
        produto_generico_ncm: "" as string,
        produto_generico_descricao: "" as string,
        produto_generico_gtin: "" as string,
        produto_generico_unidade: "" as string,
        produto_generico_id: "" as string,
        produtos: [] as any,
        fetchOptions: {} as any
    })

    constructor(props: any) {
        super(props);

      this.obs.fetchOptions = debounce(this.handleBuscaProdutos.bind(this), 800);

    }

    handleChangePage(e: any) {
        SpedEfdStore.handleBuscaProdutosGenericos(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.generic_produtos_current, SpedEfdStore.obs.generic_produtos_filter)
    }

    async handleDeletar() {
        await SpedEfdStore.handleDeleteProdutos()
    }

    handleBuscaFiltered(filtro: string) {
        SpedEfdStore.obs.generic_produtos_filter = filtro
        SpedEfdStore.obs.generic_produtos_current = 1

        this.obs.fetchOptions()
    }

    async handleBuscaProdutos() {

      await SpedEfdStore.handleBuscaProdutosGenericos(SpedEfdStore.obs.selectedEmpresa.cnpj, SpedEfdStore.obs.generic_produtos_current, SpedEfdStore.obs.generic_produtos_filter)

    }

    handleEditProdutoGenerico(row) {
        this.obs.open_edit_produto_generico = true
        this.obs.produto_generico_cest = row.cest
        this.obs.produto_generico_ncm = row.ncm
        this.obs.produto_generico_descricao = row.descricao
        this.obs.produto_generico_gtin = row.gtin
        this.obs.produto_generico_unidade = row.unidade
        this.obs.produto_generico_id = row.id

        this.obs.produtos = row.produtos
    }

    onCloseGeneric() {
        this.obs.open_edit_produto_generico = false
        this.obs.produto_generico_cest = ""
        this.obs.produto_generico_ncm = ""
        this.obs.produto_generico_descricao = ""
        this.obs.produto_generico_gtin = ""
        this.obs.produto_generico_unidade = ""
    }

    async handleSaveProdutoGenerico() {

        if (this.obs.produto_generico_cest == "" || this.obs.produto_generico_cest.replace(/\_/g, "").replace(/\./g, "").length != 7) {
            toast.warning('Insira uma CEST!', {});
            return;
        }

        if (this.obs.produto_generico_ncm == "" || this.obs.produto_generico_ncm.replace(/\_/g, "").replace(/\./g, "").length != 8) {
            toast.warning('Insira um NCM!', {});
            return;
        }

        if (this.obs.produto_generico_unidade == "") {
            toast.warning('Insira uma Unidade!', {});
            return;
        }

        if (this.obs.produto_generico_descricao == "") {
            toast.warning('Insira uma Descrição!', {});
            return;
        }

        let params = {
            id: this.obs.produto_generico_id,
            cest: this.obs.produto_generico_cest.replace(/\./g, ""),
            ncm: this.obs.produto_generico_ncm.replace(/\./g, ""),
            descricao: this.obs.produto_generico_descricao,
            gtin: this.obs.produto_generico_gtin,
            unidade: this.obs.produto_generico_unidade,
            cnpj: SpedEfdStore.obs.selectedEmpresa.cnpj
        }

        await SpedEfdStore.handleUpdateProdutoGenerico(params)

        this.onCloseGeneric()
    }

    async handleDesvincularGeneric(produto: any) {
        this.obs.produtos = this.obs.produtos.filter((value: any) => {
            return value._id != produto._id;
        });
        produto.id = produto._id
        await SpedEfdStore.handleDesvincularGenerico(produto)
        await SpedEfdStore.handleBuscaProdutosGenericos(SpedEfdStore.obs.selectedEmpresa.cnpj, 1, SpedEfdStore.obs.filter_produtos_sped)
    }

    async handleDeleteProdutoGenerico(id: string) {
        await SpedEfdStore.handleDeleteProdutoGenerico(id, this.obs.produtos)
    }

    render() {

        const formaterDetalhes = (cell, row) => {
            return (
                <>
                    <MDBBtn color="default" rounded size="sm" onClick={() => this.handleEditProdutoGenerico(row)}>
                        <img src="/images/edit.png" width={15} />
                    </MDBBtn>
                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                        <MDBBtn color="default" rounded size="sm" >
                            <img src="/images/bin.png" width="25px" />

                        </MDBBtn>
                        <div>
                            <H5>Confirmar exclusão?</H5>
                            <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 15,
                                }}
                            >
                                <Button
                                    className={Classes.POPOVER_DISMISS}
                                    style={{ marginRight: 10 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    intent="danger"
                                    className={Classes.POPOVER_DISMISS}
                                    onClick={() => this.handleDeleteProdutoGenerico(row.id)}
                                >
                                    Excluir
                                </Button>
                            </div>
                        </div>
                    </Popover>
                </>
            )
        }

        const formaterVinculado = (cell, row) => {
            return (
                <>
                    <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                        <MDBBtn color="default" rounded size="sm" >
                            <img src="/images/bin.png" width="25px" />

                        </MDBBtn>
                        <div>
                            <H5>Confirmar desvinculo?</H5>
                            <p style={{ fontSize: 11 }}>Tem certeza de que deseja desvincular esse item?</p>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 15,
                                }}
                            >
                                <Button
                                    className={Classes.POPOVER_DISMISS}
                                    style={{ marginRight: 10 }}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    intent="danger"
                                    className={Classes.POPOVER_DISMISS}
                                    onClick={() => this.handleDesvincularGeneric(row)}
                                >
                                    Desvincular
                                </Button>
                            </div>
                        </div>
                    </Popover>
                </>
            );
        }

        let produtos = SpedEfdStore.obs.generic_produtos?.map(obj => {
            return (
                {
                    id: obj._id || obj.id,
                    cest: obj.cest,
                    ncm: obj.ncm,
                    gtin: obj.gtin,
                    cnpj: obj.cnpj,
                    descricao: obj.descricao,
                    produtos: obj.produtos,
                    unidade: obj.unidade
                }
            );
        })

        return (
            <>
                <Dialog
                    isOpen={this.obs.open_edit_produto_generico}
                    onClose={() => this.obs.open_edit_produto_generico = false}
                    className="AlertUser"
                >
                    <h2 className="titleSEFAZ">Editar Produto Genérico</h2>

                    <>
                        <MDBRow>
                            <MDBCol>
                                <FormGroup label="CEST">
                                    <InputMask
                                        mask="99.999.99"
                                        className="form-control"
                                        onChange={(e) => this.obs.produto_generico_cest = e.target.value}
                                        value={this.obs.produto_generico_cest} />
                                </FormGroup>
                            </MDBCol>

                            <MDBCol>
                                <FormGroup label="NCM">
                                    <InputMask
                                        mask="9999.99.99"
                                        className="form-control"
                                        onChange={(e) => this.obs.produto_generico_ncm = e.target.value}
                                        value={this.obs.produto_generico_ncm} />
                                </FormGroup>
                            </MDBCol>

                            <MDBCol>
                                <FormGroup label="GTIN">
                                    <InputGroup value={this.obs.produto_generico_gtin} onChange={(e) => this.obs.produto_generico_gtin = e.target.value} />
                                </FormGroup>
                            </MDBCol>

                            <MDBCol>
                                <FormGroup label="UNIDADE">
                                    <InputGroup value={this.obs.produto_generico_unidade} onChange={(e) => this.obs.produto_generico_unidade = e.target.value} />
                                </FormGroup>
                            </MDBCol>

                        </MDBRow>

                        <FormGroup label="Descrição">
                            <TextArea style={{ width: "100%" }} value={this.obs.produto_generico_descricao} onChange={(e) => this.obs.produto_generico_descricao = e.target.value} />
                        </FormGroup>

                        <FormGroup label="Produtos vinculados" style={{ marginBottom: "30px" }}>
                            <BootstrapTable
                                className="produtos-vinculados"
                                data={this.obs.produtos}
                            >
                                <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
                                <TableHeaderColumn dataField="cest" width="20%">CEST</TableHeaderColumn>
                                <TableHeaderColumn dataField="ncm_sh" width="20%">NCM</TableHeaderColumn>
                                <TableHeaderColumn dataField="gtin" width="30%">GTIN</TableHeaderColumn>
                                <TableHeaderColumn dataField="unidade" width="20%">UNIDADE</TableHeaderColumn>
                                <TableHeaderColumn dataField="descricao" width="80%">DESCRIÇÃO</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={formaterVinculado} width="15%"></TableHeaderColumn>
                            </BootstrapTable>
                        </FormGroup>
                    </>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Cancelar" onClick={() => this.onCloseGeneric()} />
                        <Button text="Salvar" intent="primary" onClick={() => this.handleSaveProdutoGenerico()} />
                    </div>
                </Dialog>

                <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
                    <MDBCol md="3">
                        <InputGroup
                            round
                            leftIcon="search"
                            style={{ borderRadius: 10 }}
                            placeholder="Filtrar (ID, NCM, CEST, GTIN, DESCRIÇÃO)"
                            value={SpedEfdStore.obs.generic_produtos_filter}
                            onChange={(e: any) => this.handleBuscaFiltered(e.target.value)} />
                    </MDBCol>

                </MDBRow>

                <BootstrapTable
                    data={produtos}
                >
                    <TableHeaderColumn dataField="id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
                    <TableHeaderColumn dataField="id" width="40%">ID</TableHeaderColumn>
                    <TableHeaderColumn dataField="cest" width="20%">CEST</TableHeaderColumn>
                    <TableHeaderColumn dataField="ncm" width="20%">NCM</TableHeaderColumn>
                    <TableHeaderColumn dataField="gtin" width="20%">GTIN</TableHeaderColumn>
                    <TableHeaderColumn dataField="unidade" width="20%">UNIDADE</TableHeaderColumn>
                    <TableHeaderColumn dataField="descricao" width="80%">DESCRIÇÃO</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={formaterDetalhes} width="15%"></TableHeaderColumn>
                </BootstrapTable>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                    <Pager
                        currentPage={SpedEfdStore.obs.generic_produtos_current}
                        totalCount={SpedEfdStore.obs.generic_produtos_length}
                        pageSize={10}
                        onPageChange={(page) => this.handleChangePage(SpedEfdStore.obs.generic_produtos_current = page)}
                    />
                </div>
            </>
        )
    }
}